import React from 'react';
import { Calendar, MapPin, Building, Users as UsersIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDate } from './helpers';

export const DetailsCard = ({ report }) => (
  <Card>
    <CardHeader>
      <CardTitle>Detalhes</CardTitle>
    </CardHeader>
    <CardContent className="grid grid-cols-2 gap-4">
      {report.incident_date && (
        <div className="flex items-start gap-2">
          <Calendar className="w-4 h-4 text-slate-400 mt-0.5" />
          <div>
            <p className="text-xs text-slate-500">Data do Incidente</p>
            <p className="text-sm text-slate-700">{formatDate(report.incident_date)}</p>
          </div>
        </div>
      )}
      {report.location && (
        <div className="flex items-start gap-2">
          <MapPin className="w-4 h-4 text-slate-400 mt-0.5" />
          <div>
            <p className="text-xs text-slate-500">Local</p>
            <p className="text-sm text-slate-700">{report.location}</p>
          </div>
        </div>
      )}
      {report.department && (
        <div className="flex items-start gap-2">
          <Building className="w-4 h-4 text-slate-400 mt-0.5" />
          <div>
            <p className="text-xs text-slate-500">Departamento</p>
            <p className="text-sm text-slate-700">{report.department}</p>
          </div>
        </div>
      )}
      {report.persons_involved && (
        <div className="flex items-start gap-2 col-span-2">
          <UsersIcon className="w-4 h-4 text-slate-400 mt-0.5" />
          <div>
            <p className="text-xs text-slate-500">Pessoas Envolvidas</p>
            <p className="text-sm text-slate-700">{report.persons_involved}</p>
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);
